import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import alinen_logo from "../images/Alinen_logo_transparent.png";
import alinen_logo_small from "../images/Alinen_logo_small.png";
import { Bars, HeaderContainer } from "../styled";
import { Nav, Navbar } from "react-bootstrap";
import { useLanguage } from "../i18n/LanguageContext";

const Header = () => {
  const { locale, setLocale, t } = useLanguage();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const closeNavbar = () => setExpanded(false);

  return (
    <HeaderContainer>
      <Link to="/">
        <div id="home">
          {/* Blurred/small placeholder image */}
          <img
            className={imageLoaded ? "hidden" : "placeholder"}
            src={alinen_logo_small}
            alt="Alinen"
          />
          {/* Main high-quality image */}
          <img
            className={imageLoaded ? "loaded" : "hidden"}
            src={alinen_logo}
            alt="Alinen"
            onLoad={() => setImageLoaded(true)}
          />
        </div>
      </Link>
      <Navbar collapseOnSelect expand="lg" expanded={expanded} onToggle={setExpanded}>
        <Navbar.Toggle aria-controls="responsive-navbar-nav">
          <Bars />
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-lg-auto">
            <Nav.Link href="#" as="span" onClick={closeNavbar}>
              <Link className="color-nav" to="#home">
                {t.nav.home}
              </Link>
            </Nav.Link>
            <Nav.Link href="#" as="span" onClick={closeNavbar}>
              <Link className="color-nav" to="#band">
                {t.nav.band}
              </Link>
            </Nav.Link>
            <Nav.Link href="#" as="span" onClick={closeNavbar}>
              <Link className="color-nav" to="#music">
                {t.nav.music}
              </Link>
            </Nav.Link>
            <Nav.Link href="#" as="span" onClick={closeNavbar}>
              <Link className="color-nav" to="#live">
                {t.nav.live}
              </Link>
            </Nav.Link>
            <Nav.Link href="#" as="span" onClick={closeNavbar}>
              <Link className="color-nav" to="#pix">
                {t.nav.pix}
              </Link>
            </Nav.Link>
            <Nav.Link href="#" as="span" onClick={closeNavbar}>
              <Link className="color-nav" to="#contact">
                {t.nav.contact}
              </Link>
            </Nav.Link>
          </Nav>
          <Nav className="language-switcher-nav" aria-label={t.lang.switchLabel}>
            <div className="language-switcher">
              <button
                type="button"
                className={`language-switcher__btn${locale === "fi" ? " language-switcher__btn--active" : ""}`}
                onClick={() => setLocale("fi")}
                aria-pressed={locale === "fi"}
              >
                {t.lang.fi}
              </button>
              <span className="language-switcher__sep" aria-hidden>
                |
              </span>
              <button
                type="button"
                className={`language-switcher__btn${locale === "en" ? " language-switcher__btn--active" : ""}`}
                onClick={() => setLocale("en")}
                aria-pressed={locale === "en"}
              >
                {t.lang.en}
              </button>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </HeaderContainer>
  );
};

export default Header;
